const LeaTypes = {
    School: 1,
    District: 2,
    State: 3,
    Coop: 10,
    County: 20
}

export { LeaTypes }